import React from "react";
import classNames from "classnames";
import * as styles from "./styles_vanilla.css";

export type RemocalStatusIconProps = {
  isCurrentSandboxReady: boolean;
  isBaseline: boolean;
};

export const RemocalStatusIcon: React.FC<RemocalStatusIconProps> = ({
  isCurrentSandboxReady,
  isBaseline,
}) => (
  <span
    className={classNames({
      [styles.pillIconVariants.notReady]: !isBaseline && !isCurrentSandboxReady,
      [styles.pillIconVariants.disconnected]: isBaseline,
      [styles.pillIconVariants.default]: isCurrentSandboxReady && !isBaseline,
    })}
    aria-hidden="true"
  />
);
